// Goals and time commitment options for onboarding

export type UserGoal =
  | "competition-prep"
  | "everyday-math"
  | "vedic-mastery"
  | "exam-prep";
export type WeeklyHours = 1 | 2 | 3 | 5;

export interface GoalOption {
  id: UserGoal;
  title: string;
  description: string;
  icon: "Trophy" | "Calculator" | "BookOpen" | "GraduationCap";
  recommendedHours: WeeklyHours;
  color: string;
}

export const GOAL_OPTIONS: GoalOption[] = [
  {
    id: "competition-prep",
    title: "Competition Prep",
    description:
      "Prepare for math olympiads and competitions with advanced techniques",
    icon: "Trophy",
    recommendedHours: 5,
    color: "amber",
  },
  {
    id: "everyday-math",
    title: "Everyday Math",
    description: "Quick mental calculations for shopping, tips, and daily life",
    icon: "Calculator",
    recommendedHours: 1,
    color: "green",
  },
  {
    id: "vedic-mastery",
    title: "Vedic Mastery",
    description:
      "Master ancient Indian calculation techniques for speed and accuracy",
    icon: "BookOpen",
    recommendedHours: 3,
    color: "purple",
  },
  {
    id: "exam-prep",
    title: "Exam Preparation",
    description:
      "Boost your speed and accuracy for standardized tests and exams",
    icon: "GraduationCap",
    recommendedHours: 2,
    color: "blue",
  },
];

export interface TimeOption {
  hours: WeeklyHours;
  label: string;
  description: string;
  dailyMinutes: string;
  recommended?: boolean;
}

export const TIME_OPTIONS: TimeOption[] = [
  {
    hours: 1,
    label: "1 hour/week",
    description: "Light practice",
    dailyMinutes: "~10 min/day",
  },
  {
    hours: 2,
    label: "2 hours/week",
    description: "Moderate practice",
    dailyMinutes: "~15-20 min/day",
  },
  {
    hours: 3,
    label: "3 hours/week",
    description: "Recommended",
    dailyMinutes: "~25-30 min/day",
    recommended: true,
  },
  {
    hours: 5,
    label: "5+ hours/week",
    description: "Intensive practice",
    dailyMinutes: "~45+ min/day",
  },
];

export function getGoalById(goalId: UserGoal): GoalOption | undefined {
  return GOAL_OPTIONS.find((g) => g.id === goalId);
}

export function getRecommendedHours(goalId: UserGoal): WeeklyHours {
  const goal = getGoalById(goalId);
  return goal?.recommendedHours ?? 3;
}
